import { Image } from 'antd';
import ActionHeader from '../../../components/actionHeader';
import Page from '../../../components/page';
import { useTranslation } from 'react-i18next';

const SkillsetInsight = () => {
  const { t } = useTranslation();
  return (
    <Page header={<ActionHeader title={t('skillset_reserve_coming_soon')} />}>
      <div style={{ padding: 24 }}>
        <Image
          src="/skillset_insight.png"
          preview={false}
          style={{ width: '100%' }}
        ></Image>
      </div>
    </Page>
  );
};

export default SkillsetInsight;
